module.exports = __webpack_public_path__ + "img/ix42_logo.80cec603.png";